import { SET_FLOATING_IFRAME_DIMENSIONS } from '../actions/ActionTypes';
const initialState = {
  iframeDimensions: {
    height: 0,
    width: 0
  }
};
const floatingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FLOATING_IFRAME_DIMENSIONS:
      return Object.assign({}, state, {
        iframeDimensions: action.payload
      });
    default:
      return state;
  }
};
export default floatingReducer;